export default "__VITE_ASSET__CJ2sxaOy__"